/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ConfigV1Dto } from './ConfigV1Dto';
export type CreateClauseSchemaFieldV1Dto = {
  /**
   * label for this ClauseSchema.
   */
  label: string;
  /**
   * Type of the value.
   */
  valueType: CreateClauseSchemaFieldV1Dto.valueType;
  /**
   * config options for the value associated with the clause type if applicable.
   */
  config?: ConfigV1Dto;
  /**
   * Whether the field is mandatory.
   */
  isMandatory: boolean;
  /**
   * The sort order of this field within the Clause (display purpose).
   */
  order: number;
};
export namespace CreateClauseSchemaFieldV1Dto {
  /**
   * Type of the value.
   */
  export enum valueType {
    STRING_VALUE = 'StringValue',
    NUMBER_VALUE = 'NumberValue',
    ENUM_VALUE = 'EnumValue',
    BOOLEAN_VALUE = 'BooleanValue',
    DATE_VALUE = 'DateValue',
  }
}
